import { DatePipe } from '@angular/common';
import { Component, computed, inject, input, model, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { finalize } from 'rxjs';
import { UiModule } from '../../../../components/ui.module';
import { LocationService } from '../../../../service/location.service';
import { LocationReviewNotesResponse } from '../../../../types';

export const REVIEW_NOTES_MAX_LENGTH = 1000;

@Component({
  selector: 'app-review-notes-modal',
  imports: [UiModule, FormsModule, DatePipe],
  templateUrl: './review-notes-modal.component.html',
})
export class ReviewNotesModalComponent {
  private locationService = inject(LocationService);

  public locationId = input.required<number>();
  public locationName = input.required<string>();
  public isVisible = model<boolean>(false);
  public saved = output<LocationReviewNotesResponse>();

  public readonly maxLength = REVIEW_NOTES_MAX_LENGTH;
  public reviewNotes = signal<LocationReviewNotesResponse | null>(null);
  public notes = signal('');
  public loading = signal(false);
  public saving = signal(false);
  public lastUpdate = computed(() => {
    const reviewNotes = this.reviewNotes();
    return reviewNotes?.updated_by && reviewNotes.updated_at ? { by: reviewNotes.updated_by, at: reviewNotes.updated_at } : null;
  });

  public load() {
    this.reviewNotes.set(null);
    this.notes.set('');
    this.loading.set(true);
    this.locationService
      .getLocationReviewNotes(this.locationId())
      .pipe(finalize(() => this.loading.set(false)))
      .subscribe((reviewNotes) => {
        this.reviewNotes.set(reviewNotes);
        this.notes.set(reviewNotes.notes);
      });
  }

  public save() {
    this.saving.set(true);
    this.locationService
      .updateLocationReviewNotes(this.locationId(), { notes: this.notes() })
      .pipe(finalize(() => this.saving.set(false)))
      .subscribe((reviewNotes) => {
        this.saved.emit(reviewNotes);
        this.isVisible.set(false);
      });
  }
}
